import { createGlobalStyle } from "styled-components";
import { spacingPx } from "../../mixins/formatters";
import "react-horizontal-scrolling-menu/dist/styles.css";
export const GlobalStyle = createGlobalStyle `
  /* chrome and chromium based */
  .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar {
    display: none;
  }

  .react-horizontal-scrolling-menu--scroll-container {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    gap: ${({ _itemGap }) => spacingPx(_itemGap)};
  }
`;
export default GlobalStyle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Ib3Jpem9udGFsU3dpcGVhYmxlL3N0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3RELE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSx5QkFBeUIsQ0FBQztBQUVwRCxPQUFPLGlEQUFpRCxDQUFDO0FBRXpELE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxpQkFBaUIsQ0FBdUI7Ozs7Ozs7OztXQVN4RCxDQUFDLEVBQUUsUUFBUSxFQUFFLEVBQUUsRUFBRSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUM7O0NBRS9DLENBQUM7QUFFRixlQUFlLFdBQVcsQ0FBQyJ9